// UI constants
export const UiConstants = {
	label: {
		confirm: '확인',
		cancel: '취소'
	},
	msg: {}
};
